import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { isFourLevelsDeep } from '@fundera/fundera-utilities';
import MenuContent from './SecondaryNavDesktopMenuContent';

import * as styles from './SecondaryNavDesktop.module.less';

const SecondaryNavDesktopMenu = ({ links }) => {
  const isLargeDropdown = isFourLevelsDeep(links);
  const innerMenu = isLargeDropdown ? (
    <div className={styles.menuLargeDropdown}>
      {links.map(link => (
        <div key={`${link.text}`} className={styles.menuLargeDropdownSection}>
          <div className={styles.menuLargeDropdownSectionHeader}>
            {link.text}
          </div>
          <MenuContent links={link.childItems} />
        </div>
      ))}
    </div>
  ) : (
    <MenuContent links={links} />
  );

  return (
    <div
      className={classnames(styles.menu, {
        [styles.menuLarge]: isLargeDropdown,
      })}
    >
      <div className={styles.menuDropdown}>
        <div className={styles.menuTopic}>{innerMenu}</div>
      </div>
    </div>
  );
};

SecondaryNavDesktopMenu.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({ url: PropTypes.string, text: PropTypes.string })
  ),
};

SecondaryNavDesktopMenu.defaultProps = {
  links: [],
};

export default SecondaryNavDesktopMenu;
